export const SERVICES_BASE_URL = process.env.REACT_APP_BASE_URL;
export const ADMIN_SERVICE_URL =
  process.env.REACT_APP_ADMIN_SERVICE_URL || `${SERVICES_BASE_URL}:5000`;

export const NOTIFICATION_SERVICE_URL =
  process.env.REACT_APP_NOTIFICATION_SERVICE_URL ||
  `https://notification.bot.go.tz`;

export const dateFormat = "DD-MMM-YYYY";
export const dateFormatWithTime = "DD-MMM-YYYY HH:mm:ss";
export const oracleDateFormat = "DD-MMM-YYYY hh:mm:ss A";
